export default __webpack_public_path__ + "static/media/vector_up.e91f4c6c.svg";